/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.28",
    versionName: "0.2.0-nightly.2026.4.28",
    versionChannel: "nightly",
    buildDate: "2026-04-28T00:21:44.129Z",
    commitHash: "741f8e1c5420547f845581d071d5b448e680943f",
};
